<template>
    <div>
        <b-modal :id="modalId"
            modal-class="modal-serial"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <SerialHeader
                        :serialModel="serialModel" />
                </div>
                <div class="modal-base-body">
                    <Serial
                        :lbl="lbl"
                        :serialModel="serialModel"
                        :controller="controller" />
                    <div id="redeem_on_date">
                        {{getRedeemMessage()}}
                    </div>
                    <SerialTimer
                        :lbl="lbl"
                        :serialModel="serialModel"
                        :controller="controller" />
                </div>
                <div class="modal-base-footer">
                    <SerialFooter />
                    <button @click="close()">Close</button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Moment from 'moment';
//helper
import Locale from '@/helper/locale/Locale.js';
import Util from '@/helper/Utility.js';
//component
import Serial from './Component/Serial.vue';
import SerialFooter from './Component/SerialFooter.vue';
import SerialHeader from './Component/SerialHeader.vue';
import SerialTimer from './Component/SerialTimer.vue';

export default {
    name: 'SerialModal',
    components: {
        Serial,
        SerialFooter,
        SerialHeader,
        SerialTimer
    },
    props: {
        controller: Object,
        modalId: String
    },
    data: function () {
        return {
            lbl: Locale.getLbl(),

            serialModel: {},
            tag: null,

            busModal: null
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        //event
        close: function () {
            this.hide();
        },
        getRedeemMessage: function () {
            var expireDate = this.serialModel.redeemTimestamp;
            var result = Moment.unix(expireDate).utc();
            var year = result.format('YYYY');
            if (Locale.getLocaleCode() === 1054) {
                year = result.get('year') + 543;
            }

            var day = result.format('DD');
            var month = result.format('MM');
            var date = `${day} ${month} ${year} - ${result.format('HH:mm')}`;

            return Util.stringFormat(this.lbl.serial.redeem_on, date);
        },
        //modal
        show: function (config) {
            this.serialModel = config.serialModel;
            this.tag = config.tag;

            this.$bvModal.show(this.modalId);
        },
        hide: function () {
            this.$bvModal.hide(this.modalId);
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
#redeem_on_date {
    font-size: 1.45rem;
    line-height: 1;
    text-align: center;
}
</style>
<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/modal.scss";
.modal-serial {
    @extend %modal-base;
}
</style>
